@if (shouldRender) {
    <div
        id="section-{{ section.uuid }}"
        class="section-container"
        [ngClass]="sectionClasses"
        [ngStyle]="{
            'background-color': backGroundColor,
        }">
        <div class="row">
            @for (block of section.blocks; track block.uuid) {
                <div class="{{ block.colWidth }}">
                    <app-sb-block [section]="section" [block]="block" />
                </div>
            }
        </div>
    </div>
}
